/* 🤖 this file was generated by svg-to-ts */

export type PorIcon =
    | 'caretdown'
    | 'check'
    | 'chevronleft'
    | 'chevronright'
    | 'circleclose'
    | 'cross'
    | 'email'
    | 'error_mail'
    | 'favorites'
    | 'info'
    | 'lock'
    | 'magnifier'
    | 'openinnew'
    | 'satellite'
    | 'spinner'
    | 'train';
export interface PorIconModel {
    name: PorIcon;
    data: string;
}
